import React, { useEffect, useRef, useState } from "react";
import "../css/home.css";

const COUNTERS_DATA = [
  { end: 250, label: "Projects Completed" },
  { end: 180, label: "Happy Customers" },
  { end: 15, label: "Expert Cleaners" },
  { end: 8, label: "Years Experience" },
];

const Counter = () => {
  const sectionRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);
  const [counts, setCounts] = useState(COUNTERS_DATA.map(() => 0));

  /* 🔥 Detect scroll */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  /* 🔢 Counter logic */
  useEffect(() => {
    if (!hasStarted) return;

    const duration = 2000;
    const interval = 20;
    const steps = duration / interval;
    const increments = COUNTERS_DATA.map(c => c.end / steps);

    const timer = setInterval(() => {
      setCounts(prev =>
        prev.map((val, i) => {
          const next = val + increments[i];
          return next >= COUNTERS_DATA[i].end
            ? COUNTERS_DATA[i].end
            : Math.ceil(next);
        })
      );
    }, interval);

    return () => clearInterval(timer);
  }, [hasStarted]);

  return (
    <section
      ref={sectionRef}
      className={`counter-section ${hasStarted ? "show" : ""}`}
    >
      <div className="container">
        {/* 🔥 Heading */}
        <div className="counter-heading">
          <h2>Our Achievements</h2>
          <p>We deliver quality cleaning with proven results</p>
        </div>

        {/* 🔢 Counters */}
        <div className="counter-grid">
          {COUNTERS_DATA.map((item, index) => (
            <div className="counter-box" key={index}>
              <h3 className="counter-number">{counts[index]}+</h3>
              <p className="counter-label">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Counter;
